/**
 * スクロール連動フェードアップ
 * 対象要素がビューポートに入ったら blur / translateY / opacity でふわっと表示する。
 * ※ お知らせ詳細の本文（.p-news-detail__body）など、除外したい箇所は対象に含めない。
 */
export function fadeInFunc() {
  // フェード対象のセレクタ（サイト全体の主要コンテンツ）
  // ※ 初期非表示は src/scss/common/_animation.scss の $fade-targets と一致させること
  const SELECTORS = [
    // 共通（下層ページ見出し）
    // '.l-page__heading',
    // トップ
    '.p-home-kv__switch',
    '.p-home-kv__heading',
    '.p-home-news',
    '.p-home-movie__header-image',
    '.p-home-movie__header-deco.is-right',
    '.p-home-movie__content',
    '.p-home-story__text',
    '.p-home-character__inner',
    '.p-home-cast__group-ttl',
    '.p-home-cast__staff',
    // お知らせ一覧
    // '.p-news-archive__list',
    // '.p-news-archive__pagination',
    // お知らせ詳細（記事カードとボタン。タイトル単体には付けない）
    // '.p-news-detail__article',
    // '.p-news-detail__button',
    // 404
    '.p-not-found__text',
    '.p-not-found__button',
    // フッター（コピーライトは除く）
    '.l-footer__top-illust',
    '.l-footer__logo',
    '.l-footer__nav',
    '.l-footer__x',
  ];

  const targets = [];
  SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      // お知らせ詳細の本文配下は除外
      if (el.closest('.p-news-detail__body')) return;
      targets.push(el);
    });
  });

  if (targets.length === 0) return;

  // IntersectionObserver 非対応環境では全て表示状態にする
  if (!('IntersectionObserver' in window)) {
    targets.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  // 同じ親に並ぶ要素には少しずつディレイを付けてスタッガー表示
  let lastParent = null;
  let groupIndex = 0;
  targets.forEach((el) => {
    if (el.parentElement === lastParent) {
      groupIndex += 1;
    } else {
      groupIndex = 0;
      lastParent = el.parentElement;
    }
    if (groupIndex > 0) {
      el.style.transitionDelay = Math.min(groupIndex * 0.08, 0.4) + 's';
    }
  });

  const observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1,
    }
  );

  targets.forEach((el) => observer.observe(el));
}
